<template>

  <div>
    <div id="breadcrumb">
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ path:'/home' }">
            <i class="fa fa-home"></i> Home
          </router-link>
        </li>
        <li>
          <small>Access Control</small>
        </li>
        <li class="active">
          <small>Data Mgmt.</small>
        </li>
      </ol>
    </div>

    <div class="tab">
      <el-tabs class="el-tabs" type="border-card">
        <el-tab-pane label="Tag Mgmt">
          <tag-list @abstractChange="changeAbstract"></tag-list>
        </el-tab-pane>

        <el-tab-pane label="Tag Table Mgmt">
          <tag-table ref="tagTable"></tag-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>

</template>

<script>

  import tagList from '@/view/acs/tag/dialog/tag_list3.vue'
  import tagTable from '@/view/acs/table/config_field_tag.vue'

export default {
  props: {},
  components: {
    tagList,
    tagTable
  },
  data() {
    return {
    };
  },
  computed: {},
  created() {

  },
  mounted() {

  },
  methods: {
    changeAbstract(){
      this.$refs.tagTable.changeAbstractTree();
    }

  }
};
</script>
<style scoped>
.el-input--small .el-input__inner {
  height: 25px;
  line-height: 25px;
}
.el-button--mini,
.el-button--small {
  height: 25px;
}
.el-form-item__content,
.el-form-item__label {
  line-height: 30px;
}
</style>
<style lang="scss" scoped>
.mp {
  margin: 0 !important;
  padding: 0 !important;
}
h5 {
  font-weight: 600;
  margin: 0;
  padding: 5px 0 10px 0;
}

.describe-title {
  margin: 0;
  font-size: 12px;
}

[v-cloak] {
  display: none;
}
.breadcrumb {
  background-color: transparent !important;
  margin-bottom: 0px;
}
.title {
  margin-left: 16px;
  font-size: 20px;
}
.tab {
  background: #fff;
  margin: 0 10px;
  padding-left: 10px;
  height: 570px;
  min-width: 770px;
  overflow-x: auto;
}
.area {
  min-width: 345px;
  margin-top: 10px;
  border: 1px solid #d1dbe5;
  border-radius: 4px;
  background-color: #f6f8f9;
  font-size: 10px;
  .area-2 {
    height: 380px;
    // background: #58a;
    width: 100%;
    overflow: hidden;
    overflow-y: auto;
    overflow-x: auto;
    /* 设置滚动条的样式 */
    &::-webkit-scrollbar {
      width: 5px;
      background-color: #fff;
    }
    /* 滚动槽 */
    &::-webkit-scrollbar-track {
      // border-radius:10px;
    }

    /* 滚动条滑块 */
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      // background:#f6f8f9;
      background: #ccc;
    }
  }
  .area-left {
    background: #ddd;
  }
  .area-right {
    background: #eee;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/acs/tag/tag_list2.vue